export const SCREEN_SIZE = {
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
};
export const TYPOGRAPHY_SIZE = {
    GIGANTIC: 'gigantic',
    HUGE: 'huge',
    LARGE: 'large',
    BIGGER: 'bigger',
    BIG: 'big',
    NORMAL: 'normal',
};
export const COLORS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    DARK_GREY: 'darkGrey',
    GREY: 'grey',
    LIGHT_GREY: 'lightGrey',
    BLACK: 'black',
    WHITE: 'white',
};
export const BOX_SHADOW_TYPES_VALUES = {
    LOW: 'LOW',
    HIGH: 'HIGH',
    NONE: 'NONE',
};
export const BOOLEAN_VALUES = {
    FALSE: false,
    TRUE: true,
};
export const ALIGNMENT_OPTIONS = {
    CENTER: 'CENTER',
    LEFT: 'LEFT',
};
export const ASPECT_RATIO_VALUES = {
    DEFAULT: {
        x: 16,
        y: 9,
    },
};
export const SEMANTIC_TAG_VALUES = {
    H1: 'h1',
    H2: 'h2',
    h3: 'h3',
    H4: 'h4',
    P: 'p',
    SPAN: 'span',
};
export const CONFIGURATION_TYPES = {
    COLOR: 'COLOR',
    TYPOGRAPHY: 'TYPOGRAPHY',
    NUMBER: 'NUMBER',
    BOX_SHADOW: 'BOX_SHADOW',
    BOOLEAN: 'BOOLEAN',
    ALIGNMENT: 'ALIGNMENT',
    ASPECT_RATION: 'ASPECT_RATION',
    SEMANTIC_TAG: 'SEMANTIC_TAG',
};
